import React from "react"
import LinkCard, { LinkCardProps } from "./LinkCard"

export interface LinkCardsProps {
  /**
   * The cards to display
   */
  linkCards: LinkCardProps[]
  /**
   * The size of the cards, used to determine the default number of columns to
   * display
   */
  size?: "base" | "compact"
  /**
   * The number of columns to display in each row
   */
  columns?: 2 | 3 | 5
  /**
   * The heading element to use for each card’s heading. Used to ensure the page
   * outline is semantic.
   */
  headingElement?: "h1" | "h2" | "h3" | "h4" | "h5" | "h6"
}

/**
 * A component to display a collection of cards in a grid
 */
const LinkCards = ({ linkCards, size = "base", columns, headingElement = "h3"}: LinkCardsProps) => {
  const widthClassName = {
    2: "w-full sm:w-1/2",
    3: "w-full sm:w-1/2 lg:w-1/3",
    5: "w-1/2 md:w-1/5",
  }[columns ? columns : size === "compact" ? 5 : 3]

  return (
    <div
      className={`flex flex-wrap -ml-4 -mt-4 md:-ml-6 md:-mt-6 ${
        size === `compact` ? `justify-center` : ``
      }`}
    >
      {linkCards.map((linkCard) => {
        return (
          <div
            className={`${widthClassName} pl-4 mt-4 md:pl-6 md:mt-6 flex items-stretch`}
            key={linkCard.id}
          >
            <LinkCard
              className="w-full"
              description={linkCard.description}
              heading={linkCard.heading}
              headingElement={headingElement}
              image={linkCard.image}
              label={linkCard.label}
              linkTo={linkCard.linkTo}
              size={size}
            />
          </div>
        )
      })}
    </div>
  )
}

export default LinkCards
